export const menu = {
    label: 'CheckIns',
    icon: 'pi pi-fw pi-list',
    to: '/agenciaconceito/checkins/listar',
    rules: ['AGECON-CHECKIN-00'],
};
